import styled from 'astroturf/react'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
import { Loader } from '@calendly/ui/components/loader'

import Icon from 'components/calendar_provider_icon'
import _AccountLoader from "styles-AccountLoader.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/popup/styles.js?styleId=AccountLoader";
import _Wrapper from "styles-Wrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/popup/styles.js?styleId=Wrapper";
import _SubcalendarList from "styles-SubcalendarList.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/popup/styles.js?styleId=SubcalendarList";
import _Subcalendar from "styles-Subcalendar.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/popup/styles.js?styleId=Subcalendar";
import _CalendarLine from "styles-CalendarLine.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/popup/styles.js?styleId=CalendarLine";
import _CalendarIcon from "styles-CalendarIcon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability/popup/styles.js?styleId=CalendarIcon";


export const AccountLoader = /*#__PURE__*/styled(Loader, null, {
  displayName: "AccountLoader",
  styles: _AccountLoader
})

export const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper
})

export const SubcalendarList = /*#__PURE__*/styled('ul', null, {
  displayName: "SubcalendarList",
  styles: _SubcalendarList
})

export const Subcalendar = /*#__PURE__*/styled('li', null, {
  displayName: "Subcalendar",
  styles: _Subcalendar
})

export const CalendarLine = /*#__PURE__*/styled('div', null, {
  displayName: "CalendarLine",
  styles: _CalendarLine
})

export const CalendarIcon = /*#__PURE__*/styled(Icon, null, {
  displayName: "CalendarIcon",
  styles: _CalendarIcon
})
